import React from "react";
import "../Styles/ContactPRIntroduction.css";

const ContactPRIntroduction = () => {
  return (
    <>
      <section className="sectionContactPRIntroduction">
        <p className="ContactPRIntroText">
          At RCCG Tabernacle of Meeting, we believe in the power of prayer.
          James 5:16 reminds us, “The prayer of a righteous person is powerful
          and effective.” Whatever you're facing today — joy or sorrow, victory
          or struggle, thanksgiving or a heavy burden — you don't have to carry
          it alone.
          <br /> <br />
          Our prayer team is here, ready to stand with you in faith and lift
          your needs before the throne of grace. No request is too big or too
          small for our God. Share your prayer request with us today, and let us
          agree with you in prayer.
          <br /> <br />
          We also celebrate answered prayers! If God has done something
          wonderful in your life, we'd love to rejoice with you.
        </p>
      </section>
    </>
  );
};

export default ContactPRIntroduction;
